module.exports = __webpack_public_path__ + "static/media/two_directional_boxes_2.554629bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/svg/two_directional_boxes_2.svg
// module id = 1402
// module chunks = 0